import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeature from './Component/SummaryFeature';
import { changeIsSummaryOpened, initializeSections } from '../../model/configuratorSlice';
import { CloseButton, CloseButtonRollover } from '../../shared/svg/components';
import { currencyFormatter } from '../../utils/currencyFormatter';
import IsNullOrUndefined from '../../utils/ObjectUtils';

const SummarySectionsListMobile = () => {
  const {
     settings, sections, categories, rooms, userFlat, isSummaryOpened, summaryShots, totalPrice, legalSettings,
    } = useSelector(state => state.configurator);
  const [topShot, setTopShot] = useState(null);
  const [bottomShot, setBottomShot] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {

  }, [summaryShots]);

  useEffect(() => {
    dispatch(initializeSections());

    if (summaryShots != null && summaryShots.length === 2) {
      setTopShot(summaryShots[0]);
      setBottomShot(summaryShots[1]);
    }
  }, [isSummaryOpened]);

  useEffect(() => {

  }, [summaryShots]);

  // console.log(`sections Josep: ${JSON.stringify(sections, null, 2)}`);
  return (
    <div className="summary-sections-list-mobile">
      <div className="container-images">
        <div className="left-image">
          {topShot !== null && (
            <img src={`${settings.shots_base_url}/${topShot}.jpg`} alt="" />
          )}
        </div>
        {/* <div className="legal-text">{legalSettings.legalNote}</div> */}
      </div>
      <button className="close-button" type="button" onClick={() => dispatch(changeIsSummaryOpened(false))}>
        <CloseButton className="close-default" /><CloseButtonRollover className="close-over" />
      </button>
      <div className="container-header">
        <div className="summary-sections-list-header">
          <div className="title">Su vivienda</div>
          {/* <span>|</span>
        <div className="flat-name">{userFlat}</div> */}
        </div>
        {/* eslint-disable-next-line max-len */}
        <div className="description">A continuación se muestra un resumen de las opciones que ha seleccionado:
        </div>
      </div>
      <div className="container-sections">
        {!IsNullOrUndefined(rooms) && rooms.map((room, index) => (
          <>
            <SummarySectionTitle title={room.name} />
            <div className="summary-feature-container">
              {
                              room.categories.map((roomCategory, index2) => {
                                  const category = categories.find(cat => cat.id === roomCategory.id);

                                  if (category.features !== undefined && category.features.length > 0) {
                                      const selectedFeature = category.features.find(
                                          feature => feature.id === category.selected_feature,
                                      );
                                      if (selectedFeature !== undefined) {
                                          return (
                                            <SummaryFeature
                                              categoryName={category.name}
                                              feature={selectedFeature}
                                            />
                                          );
                                      }
                                  }
                                  return null;
                              })
                          }
            </div>
          </>
              ))}
      </div>
      <div className="total-price-summary-container">
        <div className="divider" />
        <div className="total-price-row">
          <div className="title">PRECIO TOTAL (SIN IVA)</div>
          <div className="value">{currencyFormatter.format(totalPrice)}</div>
        </div>
      </div>
      <div className="legal-text">{legalSettings.legalNote}</div>
    </div>
  );
};

export default SummarySectionsListMobile;
